(function () {
  'use strict';
  function showBenefits(form, plan) {
    var core = window.BFFJourneyCore;
    var catalog = form.closest('[data-bff-catalog]');
    var box = catalog.querySelector('[data-bff-catalog-eligibility]');
    if (!core || !box) return;
    var nearby = new Set(['34684','34683','34685','34695','34677','34688','34689','34698','34660','33761','33763','33765','33759','33760','33764','33626','33755','33756','33762','33767']);
    var local = nearby.has(plan.zip), pickup = plan.mode === 'pickup';
    var now = core.clock(), today = now.year + '-' + now.month + '-' + now.day;
    var sameDay = !pickup && local && core.earliest('delivery') === today && (!plan.date || plan.date === today);
    box.replaceChildren();
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'bff-perks-close'; close.textContent = '×'; close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', function () { box.close(); }); box.appendChild(close);
    var badge = document.createElement('div'); badge.className = 'bff-perks-badge'; badge.textContent = '✦'; badge.setAttribute('aria-hidden', 'true'); box.appendChild(badge);
    var heading = document.createElement('h3');
    heading.id = 'BFFPerksHeading';
    heading.textContent = pickup || local ? 'Your online perks are unlocked!' : 'Your online discount is unlocked!';
    box.appendChild(heading);
    function line(title, detail) {
      var p = document.createElement('p'), strong = document.createElement('strong');
      strong.textContent = title; p.className = 'bff-perks-item'; p.appendChild(strong); p.appendChild(document.createTextNode(detail)); box.appendChild(p);
    }
    if (pickup) line('Store pickup selected', 'Your pickup preference has been saved.');
    else if (!local) line('Delivery availability to confirm', 'Please call (727) 785-4000 to confirm service for this ZIP. Same-day and free delivery are not confirmed.');
    else {
      line(sameDay ? 'Same-day delivery available*' : (plan.date && plan.date > today ? 'Delivery date saved' : 'Next available delivery'),
        sameDay ? 'Order before 2 p.m. Eastern. Subject to the full address, product availability and delivery capacity.' :
        (plan.date && plan.date > today ? 'Preferred date: ' + plan.date + '. Subject to availability.' : 'Earliest available date: ' + core.earliest('delivery') + '. Today’s cutoff has passed or the shop is closed.'));
      line('FREE local delivery on $60+ orders*', 'Orders $60+ after discounts, within 20 km of our Palm Harbor shop. Final address eligibility is confirmed at checkout.');
    }
    line('5% OFF your online order', 'Online savings are applied at checkout.');
    var continueButton = document.createElement('button'); continueButton.type = 'button'; continueButton.className = 'bff-perks-continue'; continueButton.textContent = 'Great — let’s shop!'; continueButton.addEventListener('click', function () { box.close(); }); box.appendChild(continueButton);
    box.hidden = false;
    if (!pickup) {
      var summary = catalog.querySelector('[data-bff-catalog-zip-summary]');
      summary.querySelector('[data-bff-catalog-saved-zip]').textContent = plan.zip;
      summary.hidden = false; form.hidden = true;
    }
    if (!box.open) box.showModal();
  }
  document.addEventListener('bff:plan-saved', function (event) {
    if (event.target.matches('[data-bff-catalog-destination]')) showBenefits(event.target, event.detail);
  });
  function ready(scope) {
    (scope || document).querySelectorAll('[data-bff-catalog]').forEach(function (catalog) {
      var form = catalog.querySelector('[data-bff-catalog-destination]');
      if (form) {
        var zip = form.querySelector('[data-bff-find-zip]');
        var mode = form.querySelector('[data-bff-find-mode]');
        var summary = catalog.querySelector('[data-bff-catalog-zip-summary]');
        var button = catalog.querySelector('[data-bff-catalog-edit-zip]');
        if (!zip.value && mode.value !== 'pickup') {
          try {
            var saved = JSON.parse(sessionStorage.getItem('bff-delivery-address-v1'));
            var age = saved ? Date.now() - saved.savedAt : -1;
            if (saved && age >= 0 && age < 7200000 && window.BFFJourneyCore) zip.value = window.BFFJourneyCore.zip(saved.zip) || '';
          } catch (error) {}
        }
        if (zip.value && mode.value !== 'pickup') {
          summary.querySelector('[data-bff-catalog-saved-zip]').textContent = zip.value;
          summary.hidden = false;
          form.hidden = true;
        }
        if (button && !button.dataset.bffReady) {
          button.dataset.bffReady = 'true';
          button.addEventListener('click', function () {
            try { sessionStorage.removeItem('bff-delivery-address-v1'); sessionStorage.removeItem('bff-shopping-plan-v1'); } catch (error) {}
            var offer = catalog.querySelector('[data-bff-catalog-eligibility]');
            if (offer) { if (offer.open) offer.close(); offer.hidden = true; }
            zip.value = '';
            summary.hidden = true;
            form.hidden = false;
            zip.focus();
          });
        }
      }
      var filters = catalog.querySelector('[data-bff-catalog-filters]');
      if (filters && window.matchMedia && window.matchMedia('(max-width: 767px)').matches && !filters.dataset.bffReady) filters.open = false;
      if (filters) filters.dataset.bffReady = 'true';
    });
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-bff-catalog-filter-form]')) return;
    var min = form.querySelector('[data-bff-price-min]');
    var max = form.querySelector('[data-bff-price-max]');
    if (!min || !max) return;
    max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value) ? form.dataset.rangeError : '');
    if (!form.reportValidity()) event.preventDefault();
  });
  document.addEventListener('input', function (event) {
    var form = event.target.closest('[data-bff-catalog-filter-form]');
    if (form) { var max = form.querySelector('[data-bff-price-max]'); if (max) max.setCustomValidity(''); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ready(document); });
  else ready(document);
  document.addEventListener('shopify:section:load', function (event) { ready(event.target); });
})();
